import React from 'react';
import CheckTable from './components/CheckTable';
import { Box } from '@chakra-ui/react';

const MakerCheckers = () => {
  return (
    <Box mt={-5}>
      <CheckTable />
    </Box>
  );
};

export default MakerCheckers;
